import { setAutoFreeze } from 'immer';
import React from 'react';
import * as ReactIntl from 'react-intl';
import { Provider as ReduxProvider, useSelector } from 'react-redux';

import ScreenSizeProvider from '@swf/core/providers/ScreenSizeProvider';
import ThemeProvider from '@swf/core/providers/ThemeProvider';
import TimerProvider from '@swf/core/providers/TimerProvider';
import type { Store } from '@swf/core/store';
import { select } from '@swf/core/store';

import '@swf/core/styles/main.scss';

// https://immerjs.github.io/immer/docs/freezing
setAutoFreeze(false);

interface ProvidersProps {
  store: Store;
}

const IntlProvider: React.FC = ({ children }) => {
  const locale = useSelector(select.locale.getIntlLocale);
  return (
    <ReactIntl.IntlProvider locale={locale} defaultLocale={locale}>
      {children}
    </ReactIntl.IntlProvider>
  );
};

const Providers: React.FC<ProvidersProps> = ({ store, children }) => (
  <ReduxProvider store={store}>
    <ThemeProvider>
      <ScreenSizeProvider>
        <TimerProvider>
          <IntlProvider>{children}</IntlProvider>
        </TimerProvider>
      </ScreenSizeProvider>
    </ThemeProvider>
  </ReduxProvider>
);

export default Providers;
